import update from 'immutability-helper';

import Store from '../../../interfaces/Store';

export const resetConfigurationReducer = (store: Store): Store => {
  const resetState = Store.empty();
  resetState.suppressInteractions = store.suppressInteractions;
  if (store.configuration) {
    resetState.notifications = store.notifications;
  } else {
    resetState.notifications = [];
  }
  return update(store, {
    $set: resetState,
  });
};
